module.exports = __webpack_public_path__ + "img/pizza.jfif.17cea12b.webp";